// This hook consumes the data provided by useControllableTable

import { useEffect } from 'react';
import { useAsyncDebounce } from 'react-table';

export function getControlledTableProps(enabled) {
  return {
    // react-table v7 reads `manualSortBy` to disable client-side row sorting and
    // treat the server's row order as authoritative. `manualSorting` is the v8
    // option name and is IGNORED by v7 (7.8.0), so without `manualSortBy` a
    // server-paginated table still re-sorts its visible page by column accessor —
    // and an `initialState.sortBy` id that isn't among the mounted columns
    // reorders rows incorrectly (TanStack/table#2641). Keep `manualSorting` too
    // for forward-compat with a future v8 bump.
    manualSortBy: enabled,
    manualSorting: enabled,
    manualFilters: enabled,
    manualPagination: enabled,
    disableMultiSort: enabled,
    disableGrouping: enabled,
    autoResetPage: !enabled,
    autoResetExpanded: !enabled,
    autoResetGroupBy: !enabled,
    autoResetSelectedRows: !enabled,
    autoResetSortBy: !enabled,
    autoResetFilters: !enabled,
    autoResetRowState: !enabled
  };
}

export default function useControllableTableConsumer(enabled, onControlsChange, tableInstance) {
  const onControlsChangeDebounced = useAsyncDebounce(onControlsChange, 100);
  useEffect(() => {
    if (enabled) {
      onControlsChangeDebounced({
        sortBy: tableInstance.state.sortBy,
        filters: tableInstance.state.filters,
        pageIndex: tableInstance.state.pageIndex,
        pageSize: tableInstance.state.pageSize,
        pageCount: tableInstance.pageCount
      });
    }
  }, [
    tableInstance.state.sortBy,
    tableInstance.state.filters,
    tableInstance.state.pageIndex,
    tableInstance.state.pageSize,
    tableInstance.pageCount,
    onControlsChangeDebounced,
    enabled
  ]);
}
